import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "select", "content", "change" ]

  connect() {
    this.showContent();
  }
  showContent() {
    this.contentTargets.forEach((element) => {
      const labels = element.getAttribute('data-label').split(',')
      const visible = labels.includes(this.selectTarget.value)
      const requiredLabels = (element.getAttribute('data-required-label') || '').split(',').filter(Boolean)
      const orderMap = this.parseOrderMap(element.getAttribute('data-order-map'))
      const required = visible && requiredLabels.includes(this.selectTarget.value)
      const requiredMarker = element.querySelector('[data-required-marker]')
      const requiredInput = element.querySelector('[data-select-content-required-input]')
      const requiredLabel = element.querySelector('[data-required-label-state]')

      element.hidden = !visible
      element.style.order = orderMap[this.selectTarget.value] || 999

      if (requiredMarker) {
        requiredMarker.hidden = !required
      }

      if (requiredLabel) {
        requiredLabel.classList.toggle('required', required)
        requiredLabel.classList.toggle('optional', !required)
      }

      if (requiredInput) {
        requiredInput.required = required
      }
    })
    this.changeTargets.forEach((element) => {
      const labels = element.getAttribute('data-label').split(',')
      if (labels.includes(this.selectTarget.value)) {
        const event = new Event('input');
        element.dispatchEvent(event);
      }
    })
  }

  parseOrderMap(rawValue) {
    if (!rawValue) return {}

    return rawValue.split(',').reduce((map, pair) => {
      const [label, order] = pair.split(':')
      if (label && order) {
        map[label] = Number(order)
      }
      return map
    }, {})
  }

}
